<template>
  <loading-overlay v-if="!project"></loading-overlay>
  <div v-else class="my-5">
    <b-card no-body>
      <b-card-body class="p-4">
        <div class="d-print-none">
          <h1>Your order has been sent successfully!</h1>
          <h5 class="text-muted my-4 border-top border-bottom py-3">The next step is to print your labels  and attach them to your samples. Print the labels below and attach them to each sample. (You can do this by pressing <b>Ctrl+P</b>)</h5>
        </div>
        <div v-for="(submission, s_index) in submissions.models" :key="s_index" :class="[(s_index ? 'border-top mt-3' : '')]">
          <h3 class="pb-3">{{ submission.identifier }} ({{ submission.event_code }})</h3>
          <b-row  v-if="submission.getSamples() && submission.getSamples().models.length">
              <b-col
                v-for="(sample, sa_index) in submission.getSamples().models"
                :key="sa_index"
                cols="4"
              >
                <sample-customer-label
                  :customer="customer"
                  :sample="sample"
                  :submission="submission"
                  :project="project"
                ></sample-customer-label>
              </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import ProjectCollection from "../../collections/lab/ProjectCollection";
  import LoadingOverlay from "../../components/shared/LoadingOverlay";
  import SampleCustomerLabel from "../../components/lab/samples/SampleCustomerLabel";

  export default {
    name: 'CartCheckoutFinalize',
    components: {SampleCustomerLabel, LoadingOverlay},
    data() {
      return {
        customer_id: this.$store.getters.getAuthCustomerID,
        customer: null,
        project: null,
        submissions: null,
      }
    },
    methods: {
    },
    mounted() {
      let projects = new ProjectCollection();
      projects.getFilter().filterEquals('customer_id', this.customer_id);
      projects.getFilter().sortAddDesc('created_at');
      projects.fetch().then(() => {
        let project = projects.first();
        this.project = project;
        this.customer = project.getCustomer();
        this.submissions = project.getSubmissions();
      });
    }
  }
</script>
